"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
require("./export-data.component.scss");
var patient_data_service_1 = require("../../core/patient.data.service");
var date_range_selector_component_1 = require("../../common/date/date-range-selector.component");
var core_2 = require("@ngx-translate/core");
var authentication_service_1 = require("../../core/authentication/authentication.service");
var ExportDataComponent = /** @class */ (function () {
    function ExportDataComponent(patientDataService, translateService, authenticationService) {
        this.patientDataService = patientDataService;
        this.translateService = translateService;
        this.authenticationService = authenticationService;
        this.tables = [
            { name: 'device_session', displayName: 'Session' },
            { name: 'session_state', displayName: 'State' },
            { name: 'aggregate_session', displayName: 'Aggregate data' },
        ];
        this.selectedTable = this.tables[0];
    }
    Object.defineProperty(ExportDataComponent.prototype, "dateRange", {
        get: function () {
            return this._dateRange;
        },
        set: function (value) {
            this._dateRange = value;
            var range = date_range_selector_component_1.DateRange.fromRange(this._dateRange);
            this.startDate = range.startDate;
            this.endDate = range.endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExportDataComponent.prototype, "startDatePlaceholder", {
        get: function () {
            return this.translateService.instant('Start date');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExportDataComponent.prototype, "endDatePlaceholder", {
        get: function () {
            return this.translateService.instant('End date');
        },
        enumerable: true,
        configurable: true
    });
    ExportDataComponent.prototype.csvUrl = function (selectedTable) {
        return this.patientDataService.getCsvDataUrl(selectedTable, this.patientNumber, this.startDate, this.endDate);
    };
    ExportDataComponent.prototype.ngOnInit = function () {
        this.dateRange = 'week';
    };
    ExportDataComponent.prototype.setStartDate = function (date) {
        this._dateRange = null;
        this.startDate = date;
    };
    ExportDataComponent.prototype.setEndDate = function (date) {
        this._dateRange = null;
        this.endDate = date;
    };
    ExportDataComponent.prototype.download = function (selectedTable) {
        var _this = this;
        if (this.patientNumber) {
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open('get', this.csvUrl(selectedTable), true);
            xhr_1.setRequestHeader('Authorization', 'Bearer ' + this.authenticationService.token);
            xhr_1.responseType = 'blob';
            xhr_1.onload = function () {
                if (xhr_1.status === 401) {
                    _this.authenticationService.refreshToken().subscribe(function () {
                        _this.download(selectedTable);
                    }, function () {
                        _this.authenticationService.logout();
                    });
                }
                else {
                    var blob = xhr_1.response;
                    var fileName = selectedTable + '.csv';
                    _this.saveBlob(blob, fileName);
                }
            };
            xhr_1.send();
        }
    };
    ExportDataComponent.prototype.saveBlob = function (blob, fileName) {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        a.click();
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Number)
    ], ExportDataComponent.prototype, "patientNumber", void 0);
    ExportDataComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'nano-export-data',
            template: require('./export-data.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [patient_data_service_1.PatientDataService, core_2.TranslateService,
            authentication_service_1.AuthenticationService])
    ], ExportDataComponent);
    return ExportDataComponent;
}());
exports.ExportDataComponent = ExportDataComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/data/export/export-data.component.ts
// module id = 622
// module chunks = 0